import { useEffect, useRef, useState } from 'react'

// Cache to track loaded scripts globally
const loadedScripts = new Map<string, boolean>()

export const useLoadScript = (source: string, shouldLoadScript = true, language?: string) => {
    const [scriptLoad, setScriptLoad] = useState(false)
    const isMountedRef = useRef(false)
    const qualifiedChatBotScriptContent = ``

    const onScriptLoad = () => {
        if (isMountedRef.current) {
            setScriptLoad(true)
        }
    }
    const onScriptError = () => {
        if (isMountedRef.current) {
            setScriptLoad(false)
            isMountedRef.current = false
        }
    }

    useEffect(() => {
        if (shouldLoadScript && !isMountedRef.current) {
            // Prevent loading the same script twice
            if (loadedScripts.get(source) === true) {
                return undefined
            }
            loadedScripts.set(source, true)

            const script = document.createElement('script')
            script.type = 'text/javascript'
            script.async = true
            script.src = `${source}${/trustarc\.com/i.test(source) ? `&language=${language || 'en'}` : ''}`

            script.addEventListener('load', onScriptLoad)
            script.addEventListener('error', onScriptError)

            if (/qualified\.com/i.test(source)) {
                const scriptTagQualifiedFunction = document.createElement('script')
                scriptTagQualifiedFunction.textContent = qualifiedChatBotScriptContent
                document.head.appendChild(scriptTagQualifiedFunction)
                document.head.appendChild(script)
            } else {
                document.body.appendChild(script)
            }

            isMountedRef.current = true
            return () => {
                if (isMountedRef.current) {
                    isMountedRef.current = false
                    script.removeEventListener('load', onScriptLoad)
                    script.removeEventListener('error', onScriptError)
                    if (script.parentNode) {
                        script.parentNode.removeChild(script)
                    }
                }
            }
        }
        setScriptLoad(true)

        return undefined
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [source, shouldLoadScript])
    return scriptLoad
}
